import * as Sentry from '@sentry/react';
import { Route, type RouteProps } from 'react-router-dom';

import PasswordProtection from '@/components/passwordProtection';
import { UserContext } from '@/contexts';
import { useUser } from '@/hooks/useUser';

type Props = Omit<RouteProps, 'component'> & {
  component?: RouteProps['render'];
};

export const PrivateRoute = ({ component, ...rest }: Props) => {
  const { user, loading } = useUser();

  if (user) {
    Sentry.getCurrentScope().setUser({
      id: user.id,
      username: user.name,
      email: user.email
    });
  }

  const Component = component || (() => null);

  return (
    <UserContext.Provider value={{ loading, me: user }}>
      <PasswordProtection>
        <Route {...rest} render={props => <Component {...props} />} />
      </PasswordProtection>
    </UserContext.Provider>
  );
};
